export const updateActiveSurchargeService = (data) => ({
  type: "UPDATE_ACTIVE_SURCHARGE_SERVICE",
  payload: data,
});
